/* tslint:disable */
/* eslint-disable */
/**
 * Codmon facility API
 * API description in Markdown.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ChildForParentResponse
 */
export interface ChildForParentResponse {
    /**
     * 子どもid
     * @type {string}
     * @memberof ChildForParentResponse
     */
    'childId'?: string;
    /**
     * 子どもの姓名
     * @type {string}
     * @memberof ChildForParentResponse
     */
    'childName'?: string;
    /**
     * 子どもの誕生日
     * @type {string}
     * @memberof ChildForParentResponse
     */
    'childBirthday'?: string;
    /**
     * 
     * @type {Array<ChildForParentResponseMembershipsInner>}
     * @memberof ChildForParentResponse
     */
    'memberships'?: Array<ChildForParentResponseMembershipsInner>;
}
/**
 * 
 * @export
 * @interface ChildForParentResponseMembershipsInner
 */
export interface ChildForParentResponseMembershipsInner {
    /**
     * 園児id
     * @type {string}
     * @memberof ChildForParentResponseMembershipsInner
     */
    'memberId'?: string;
    /**
     * デモ園児かどうか
     * @type {boolean}
     * @memberof ChildForParentResponseMembershipsInner
     */
    'isDemo'?: boolean;
    /**
     * 施設id
     * @type {string}
     * @memberof ChildForParentResponseMembershipsInner
     */
    'facilityId'?: string;
    /**
     * 施設名
     * @type {string}
     * @memberof ChildForParentResponseMembershipsInner
     */
    'facilityName'?: string;
    /**
     * 
     * @type {ChildResponseEnrollmentPeriod}
     * @memberof ChildForParentResponseMembershipsInner
     */
    'enrollmentPeriod'?: ChildResponseEnrollmentPeriod;
    /**
     * 
     * @type {ChildResponseChildcareUnitsPeriods}
     * @memberof ChildForParentResponseMembershipsInner
     */
    'childcareUnitsPeriods'?: ChildResponseChildcareUnitsPeriods;
}
/**
 * 
 * @export
 * @interface ChildResponse
 */
export interface ChildResponse {
    /**
     * 園児id
     * @type {string}
     * @memberof ChildResponse
     */
    'childId': string;
    /**
     * 園児姓名
     * @type {string}
     * @memberof ChildResponse
     */
    'childName'?: string;
    /**
     * 施設id
     * @type {string}
     * @memberof ChildResponse
     */
    'facilityId'?: string;
    /**
     * 園児誕生日
     * @type {string}
     * @memberof ChildResponse
     */
    'birthday'?: string;
    /**
     * デモ園児かどうか
     * @type {boolean}
     * @memberof ChildResponse
     */
    'isDemo'?: boolean;
    /**
     * 
     * @type {ChildResponseEnrollmentPeriod}
     * @memberof ChildResponse
     */
    'enrollmentPeriod'?: ChildResponseEnrollmentPeriod;
    /**
     * 
     * @type {ChildResponseChildcareUnitsPeriods}
     * @memberof ChildResponse
     */
    'childcareUnitsPeriods'?: ChildResponseChildcareUnitsPeriods;
    /**
     * 
     * @type {ChildResponseContactDetails}
     * @memberof ChildResponse
     */
    'contactDetails'?: ChildResponseContactDetails;
}
/**
 * 保育の単位所属期間履歴
 * @export
 * @interface ChildResponseChildcareUnitsPeriods
 */
export interface ChildResponseChildcareUnitsPeriods {
    /**
     * 
     * @type {Array<ChildResponseChildcareUnitsPeriodsClassesInner>}
     * @memberof ChildResponseChildcareUnitsPeriods
     */
    'classes'?: Array<ChildResponseChildcareUnitsPeriodsClassesInner>;
    /**
     * 
     * @type {Array<ChildResponseChildcareUnitsPeriodsGroupsInner>}
     * @memberof ChildResponseChildcareUnitsPeriods
     */
    'groups'?: Array<ChildResponseChildcareUnitsPeriodsGroupsInner>;
}
/**
 * 
 * @export
 * @interface ChildResponseChildcareUnitsPeriodsClassesInner
 */
export interface ChildResponseChildcareUnitsPeriodsClassesInner {
    /**
     * 園児クラスid
     * @type {string}
     * @memberof ChildResponseChildcareUnitsPeriodsClassesInner
     */
    'classId'?: string;
    /**
     * 開始日
     * @type {string}
     * @memberof ChildResponseChildcareUnitsPeriodsClassesInner
     */
    'startDate'?: string;
    /**
     * 終了日
     * @type {string}
     * @memberof ChildResponseChildcareUnitsPeriodsClassesInner
     */
    'endDate'?: string;
}
/**
 * 
 * @export
 * @interface ChildResponseChildcareUnitsPeriodsGroupsInner
 */
export interface ChildResponseChildcareUnitsPeriodsGroupsInner {
    /**
     * 園児グループid
     * @type {string}
     * @memberof ChildResponseChildcareUnitsPeriodsGroupsInner
     */
    'groupId'?: string;
    /**
     * 開始日
     * @type {string}
     * @memberof ChildResponseChildcareUnitsPeriodsGroupsInner
     */
    'startDate'?: string;
    /**
     * 終了日
     * @type {string}
     * @memberof ChildResponseChildcareUnitsPeriodsGroupsInner
     */
    'endDate'?: string;
}
/**
 * 連絡先
 * @export
 * @interface ChildResponseContactDetails
 */
export interface ChildResponseContactDetails {
    /**
     * 保護者の連絡先
     * @type {Array<ChildResponseContactDetailsParentContactDetailsInner>}
     * @memberof ChildResponseContactDetails
     */
    'parentContactDetails'?: Array<ChildResponseContactDetailsParentContactDetailsInner>;
}
/**
 * 
 * @export
 * @interface ChildResponseContactDetailsParentContactDetailsInner
 */
export interface ChildResponseContactDetailsParentContactDetailsInner {
    /**
     * 保護者ID
     * @type {string}
     * @memberof ChildResponseContactDetailsParentContactDetailsInner
     */
    'parentId': string;
    /**
     * 保護者名
     * @type {string}
     * @memberof ChildResponseContactDetailsParentContactDetailsInner
     */
    'parentName': string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof ChildResponseContactDetailsParentContactDetailsInner
     */
    'mailAddress': string;
}
/**
 * 在籍期間
 * @export
 * @interface ChildResponseEnrollmentPeriod
 */
export interface ChildResponseEnrollmentPeriod {
    /**
     * 開始日
     * @type {string}
     * @memberof ChildResponseEnrollmentPeriod
     */
    'startDate'?: string;
    /**
     * 終了日
     * @type {string}
     * @memberof ChildResponseEnrollmentPeriod
     */
    'endDate'?: string;
}
/**
 * 
 * @export
 * @interface ChildcareUnitClassResponse
 */
export interface ChildcareUnitClassResponse {
    /**
     * 園児クラスid
     * @type {string}
     * @memberof ChildcareUnitClassResponse
     */
    'classId'?: string;
    /**
     * 園児クラス名
     * @type {string}
     * @memberof ChildcareUnitClassResponse
     */
    'className'?: string;
    /**
     * 学年
     * @type {string}
     * @memberof ChildcareUnitClassResponse
     */
    'grade'?: string;
}
/**
 * 
 * @export
 * @interface ChildcareUnitGroupResponse
 */
export interface ChildcareUnitGroupResponse {
    /**
     * 園児グループid
     * @type {string}
     * @memberof ChildcareUnitGroupResponse
     */
    'groupId'?: string;
    /**
     * 園児グループ名
     * @type {string}
     * @memberof ChildcareUnitGroupResponse
     */
    'groupName'?: string;
}
/**
 * 
 * @export
 * @interface ChildcareUnitsResponse
 */
export interface ChildcareUnitsResponse {
    /**
     * 
     * @type {Array<ChildcareUnitClassResponse>}
     * @memberof ChildcareUnitsResponse
     */
    'classes'?: Array<ChildcareUnitClassResponse>;
    /**
     * 
     * @type {Array<ChildcareUnitGroupResponse>}
     * @memberof ChildcareUnitsResponse
     */
    'groups'?: Array<ChildcareUnitGroupResponse>;
}
/**
 * 
 * @export
 * @interface EmployeeResponse
 */
export interface EmployeeResponse {
    /**
     * 職員id
     * @type {string}
     * @memberof EmployeeResponse
     */
    'employeeId': string;
    /**
     * 職員名
     * @type {string}
     * @memberof EmployeeResponse
     */
    'employeeName'?: string;
    /**
     * 勤務開始日
     * @type {string}
     * @memberof EmployeeResponse
     */
    'joinedDate'?: string;
    /**
     * 勤務終了日
     * @type {string}
     * @memberof EmployeeResponse
     */
    'leftDate'?: string;
    /**
     * 削除済みならtrue
     * @type {boolean}
     * @memberof EmployeeResponse
     */
    'isDeleted'?: boolean;
}
/**
 * 
 * @export
 * @interface FacilityResponse
 */
export interface FacilityResponse {
    /**
     * 施設id
     * @type {string}
     * @memberof FacilityResponse
     */
    'facilityId': string;
    /**
     * 施設種別
     * @type {number}
     * @memberof FacilityResponse
     */
    'facilityType'?: number;
    /**
     * 施設名
     * @type {string}
     * @memberof FacilityResponse
     */
    'facilityName'?: string;
    /**
     * 土曜開園
     * @type {boolean}
     * @memberof FacilityResponse
     */
    'openOnSaturday'?: boolean;
    /**
     * 日曜開園
     * @type {boolean}
     * @memberof FacilityResponse
     */
    'openOnSunday'?: boolean;
    /**
     * 
     * @type {FacilityResponseChildcareTime}
     * @memberof FacilityResponse
     */
    'childcareTime'?: FacilityResponseChildcareTime;
    /**
     * 
     * @type {FacilityResponseChildcareStandardTime}
     * @memberof FacilityResponse
     */
    'childcareStandardTime'?: FacilityResponseChildcareStandardTime;
    /**
     * 
     * @type {FacilityResponseChildcareTime}
     * @memberof FacilityResponse
     */
    'childcareShortTime'?: FacilityResponseChildcareTime;
    /**
     * β機能名（施設が複数取得される場合は常に空）
     * @type {Array<string>}
     * @memberof FacilityResponse
     */
    'betaFeatures'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FacilityResponseChildcareStandardTime
 */
export interface FacilityResponseChildcareStandardTime {
    /**
     * 保育標準開始時刻
     * @type {string}
     * @memberof FacilityResponseChildcareStandardTime
     */
    'startTime'?: string;
    /**
     * 保育標準終了時刻
     * @type {string}
     * @memberof FacilityResponseChildcareStandardTime
     */
    'endTime'?: string;
}
/**
 * 
 * @export
 * @interface FacilityResponseChildcareTime
 */
export interface FacilityResponseChildcareTime {
    /**
     * 保育開始時刻
     * @type {string}
     * @memberof FacilityResponseChildcareTime
     */
    'startTime'?: string;
    /**
     * 保育時刻
     * @type {string}
     * @memberof FacilityResponseChildcareTime
     */
    'endTime'?: string;
}
/**
 * 
 * @export
 * @interface FamilyResponse
 */
export interface FamilyResponse {
    /**
     * 家族id
     * @type {number}
     * @memberof FamilyResponse
     */
    'familyId': number;
    /**
     * 家族名
     * @type {string}
     * @memberof FamilyResponse
     */
    'familyName': string;
    /**
     * 郵便番号
     * @type {string}
     * @memberof FamilyResponse
     */
    'zipcode'?: string;
    /**
     * 都道府県id
     * @type {number}
     * @memberof FamilyResponse
     */
    'prefectureId'?: number;
    /**
     * 住所
     * @type {string}
     * @memberof FamilyResponse
     */
    'address'?: string;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface RoleEmployeeResponse
 */
export interface RoleEmployeeResponse {
    /**
     * 職員id
     * @type {string}
     * @memberof RoleEmployeeResponse
     */
    'id': string;
    /**
     * 職員名
     * @type {string}
     * @memberof RoleEmployeeResponse
     */
    'name': string;
    /**
     * 現在在職中の場合、true
     * @type {boolean}
     * @memberof RoleEmployeeResponse
     */
    'isEnrolling': boolean;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get childcare units in user\'s facility.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        childcareUnitsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/childcare-units`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get children in user\'s facility.
         * @param {boolean} [includeDemoChildren] if true, demo children are included
         * @param {boolean} [includeContactDetails] if true, contact details are included
         * @param {string} [enrollmentDateFrom] if specified, children who have already left are excluded
         * @param {string} [enrollmentDateTo] if specified, children who are not enrolled are excluded
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        childrenGet: async (includeDemoChildren?: boolean, includeContactDetails?: boolean, enrollmentDateFrom?: string, enrollmentDateTo?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/children`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeDemoChildren !== undefined) {
                localVarQueryParameter['include_demo_children'] = includeDemoChildren;
            }

            if (includeContactDetails !== undefined) {
                localVarQueryParameter['include_contact_details'] = includeContactDetails;
            }

            if (enrollmentDateFrom !== undefined) {
                localVarQueryParameter['enrollment_date_from'] = (enrollmentDateFrom as any instanceof Date) ?
                    (enrollmentDateFrom as any).toISOString().substr(0,10) :
                    enrollmentDateFrom;
            }

            if (enrollmentDateTo !== undefined) {
                localVarQueryParameter['enrollment_date_to'] = (enrollmentDateTo as any instanceof Date) ?
                    (enrollmentDateTo as any).toISOString().substr(0,10) :
                    enrollmentDateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a child in user\'s facility.
         * @param {number} id child id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        childrenIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('childrenIdGet', 'id', id)
            const localVarPath = `/children/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get employee in user\'s facility.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/employee`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get employees in the facility.
         * @param {number} facilityId facility id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilitiesFacilityIdEmployeesGet: async (facilityId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('facilitiesFacilityIdEmployeesGet', 'facilityId', facilityId)
            const localVarPath = `/facilities/{facility-id}/employees`
                .replace(`{${"facility-id"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the facility.
         * @param {number} facilityId facility id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilitiesFacilityIdGet: async (facilityId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('facilitiesFacilityIdGet', 'facilityId', facilityId)
            const localVarPath = `/facilities/{facility-id}`
                .replace(`{${"facility-id"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the user\'s facility group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilitiesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facilities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get if the user\'s facility is beta feature target.
         * @param {string} featureName beta feature name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityBetaFeaturesFeatureNameGet: async (featureName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'featureName' is not null or undefined
            assertParamExists('facilityBetaFeaturesFeatureNameGet', 'featureName', featureName)
            const localVarPath = `/facility/beta-features/{feature-name}`
                .replace(`{${"feature-name"}}`, encodeURIComponent(String(featureName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the user\'s facility.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the parent user\'s children
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parentsChildrenGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/parents/children`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the parent user\'s facility group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parentsFacilitiesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/parents/facilities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the parent user\'s family
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parentsFamilyGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/parents/family`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a child in supervisor user\'s facility.
         * @param {number} id child id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisorChildrenIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('supervisorChildrenIdGet', 'id', id)
            const localVarPath = `/supervisor/children/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get childcare units in user\'s facility.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async childcareUnitsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChildcareUnitsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.childcareUnitsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get children in user\'s facility.
         * @param {boolean} [includeDemoChildren] if true, demo children are included
         * @param {boolean} [includeContactDetails] if true, contact details are included
         * @param {string} [enrollmentDateFrom] if specified, children who have already left are excluded
         * @param {string} [enrollmentDateTo] if specified, children who are not enrolled are excluded
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async childrenGet(includeDemoChildren?: boolean, includeContactDetails?: boolean, enrollmentDateFrom?: string, enrollmentDateTo?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChildResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.childrenGet(includeDemoChildren, includeContactDetails, enrollmentDateFrom, enrollmentDateTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get a child in user\'s facility.
         * @param {number} id child id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async childrenIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChildResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.childrenIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get employee in user\'s facility.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async employeeGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.employeeGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get employees in the facility.
         * @param {number} facilityId facility id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilitiesFacilityIdEmployeesGet(facilityId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilitiesFacilityIdEmployeesGet(facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get the facility.
         * @param {number} facilityId facility id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilitiesFacilityIdGet(facilityId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilitiesFacilityIdGet(facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get the user\'s facility group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilitiesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FacilityResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilitiesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get if the user\'s facility is beta feature target.
         * @param {string} featureName beta feature name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityBetaFeaturesFeatureNameGet(featureName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityBetaFeaturesFeatureNameGet(featureName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get the user\'s facility.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facilityGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facilityGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get the parent user\'s children
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parentsChildrenGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChildForParentResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parentsChildrenGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get the parent user\'s facility group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parentsFacilitiesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FacilityResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parentsFacilitiesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get the parent user\'s family
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parentsFamilyGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FamilyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parentsFamilyGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get a child in supervisor user\'s facility.
         * @param {number} id child id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supervisorChildrenIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChildResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supervisorChildrenIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary get childcare units in user\'s facility.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        childcareUnitsGet(options?: any): AxiosPromise<ChildcareUnitsResponse> {
            return localVarFp.childcareUnitsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get children in user\'s facility.
         * @param {boolean} [includeDemoChildren] if true, demo children are included
         * @param {boolean} [includeContactDetails] if true, contact details are included
         * @param {string} [enrollmentDateFrom] if specified, children who have already left are excluded
         * @param {string} [enrollmentDateTo] if specified, children who are not enrolled are excluded
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        childrenGet(includeDemoChildren?: boolean, includeContactDetails?: boolean, enrollmentDateFrom?: string, enrollmentDateTo?: string, options?: any): AxiosPromise<Array<ChildResponse>> {
            return localVarFp.childrenGet(includeDemoChildren, includeContactDetails, enrollmentDateFrom, enrollmentDateTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a child in user\'s facility.
         * @param {number} id child id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        childrenIdGet(id: number, options?: any): AxiosPromise<ChildResponse> {
            return localVarFp.childrenIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get employee in user\'s facility.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        employeeGet(options?: any): AxiosPromise<EmployeeResponse> {
            return localVarFp.employeeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get employees in the facility.
         * @param {number} facilityId facility id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilitiesFacilityIdEmployeesGet(facilityId: number, options?: any): AxiosPromise<Array<EmployeeResponse>> {
            return localVarFp.facilitiesFacilityIdEmployeesGet(facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the facility.
         * @param {number} facilityId facility id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilitiesFacilityIdGet(facilityId: number, options?: any): AxiosPromise<FacilityResponse> {
            return localVarFp.facilitiesFacilityIdGet(facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the user\'s facility group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilitiesGet(options?: any): AxiosPromise<Array<FacilityResponse>> {
            return localVarFp.facilitiesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get if the user\'s facility is beta feature target.
         * @param {string} featureName beta feature name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityBetaFeaturesFeatureNameGet(featureName: string, options?: any): AxiosPromise<void> {
            return localVarFp.facilityBetaFeaturesFeatureNameGet(featureName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the user\'s facility.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facilityGet(options?: any): AxiosPromise<FacilityResponse> {
            return localVarFp.facilityGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the parent user\'s children
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parentsChildrenGet(options?: any): AxiosPromise<Array<ChildForParentResponse>> {
            return localVarFp.parentsChildrenGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the parent user\'s facility group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parentsFacilitiesGet(options?: any): AxiosPromise<Array<FacilityResponse>> {
            return localVarFp.parentsFacilitiesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the parent user\'s family
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parentsFamilyGet(options?: any): AxiosPromise<FamilyResponse> {
            return localVarFp.parentsFamilyGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a child in supervisor user\'s facility.
         * @param {number} id child id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisorChildrenIdGet(id: number, options?: any): AxiosPromise<ChildResponse> {
            return localVarFp.supervisorChildrenIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary get childcare units in user\'s facility.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public childcareUnitsGet(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).childcareUnitsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get children in user\'s facility.
     * @param {boolean} [includeDemoChildren] if true, demo children are included
     * @param {boolean} [includeContactDetails] if true, contact details are included
     * @param {string} [enrollmentDateFrom] if specified, children who have already left are excluded
     * @param {string} [enrollmentDateTo] if specified, children who are not enrolled are excluded
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public childrenGet(includeDemoChildren?: boolean, includeContactDetails?: boolean, enrollmentDateFrom?: string, enrollmentDateTo?: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).childrenGet(includeDemoChildren, includeContactDetails, enrollmentDateFrom, enrollmentDateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a child in user\'s facility.
     * @param {number} id child id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public childrenIdGet(id: number, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).childrenIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get employee in user\'s facility.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public employeeGet(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).employeeGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get employees in the facility.
     * @param {number} facilityId facility id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public facilitiesFacilityIdEmployeesGet(facilityId: number, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).facilitiesFacilityIdEmployeesGet(facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the facility.
     * @param {number} facilityId facility id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public facilitiesFacilityIdGet(facilityId: number, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).facilitiesFacilityIdGet(facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the user\'s facility group
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public facilitiesGet(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).facilitiesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get if the user\'s facility is beta feature target.
     * @param {string} featureName beta feature name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public facilityBetaFeaturesFeatureNameGet(featureName: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).facilityBetaFeaturesFeatureNameGet(featureName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the user\'s facility.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public facilityGet(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).facilityGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the parent user\'s children
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public parentsChildrenGet(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).parentsChildrenGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the parent user\'s facility group
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public parentsFacilitiesGet(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).parentsFacilitiesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the parent user\'s family
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public parentsFamilyGet(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).parentsFamilyGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a child in supervisor user\'s facility.
     * @param {number} id child id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public supervisorChildrenIdGet(id: number, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).supervisorChildrenIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RolesApi - axios parameter creator
 * @export
 */
export const RolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary delete a role
         * @param {number} id role id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rolesIdDelete', 'id', id)
            const localVarPath = `/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get employees of a role.
         * @param {number} id role id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesIdEmployeesGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rolesIdEmployeesGet', 'id', id)
            const localVarPath = `/roles/{id}/employees`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RolesApi - functional programming interface
 * @export
 */
export const RolesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RolesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary delete a role
         * @param {number} id role id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolesIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get employees of a role.
         * @param {number} id role id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesIdEmployeesGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleEmployeeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolesIdEmployeesGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RolesApi - factory interface
 * @export
 */
export const RolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RolesApiFp(configuration)
    return {
        /**
         * 
         * @summary delete a role
         * @param {number} id role id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.rolesIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get employees of a role.
         * @param {number} id role id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesIdEmployeesGet(id: number, options?: any): AxiosPromise<Array<RoleEmployeeResponse>> {
            return localVarFp.rolesIdEmployeesGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RolesApi - object-oriented interface
 * @export
 * @class RolesApi
 * @extends {BaseAPI}
 */
export class RolesApi extends BaseAPI {
    /**
     * 
     * @summary delete a role
     * @param {number} id role id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public rolesIdDelete(id: number, options?: AxiosRequestConfig) {
        return RolesApiFp(this.configuration).rolesIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get employees of a role.
     * @param {number} id role id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public rolesIdEmployeesGet(id: number, options?: AxiosRequestConfig) {
        return RolesApiFp(this.configuration).rolesIdEmployeesGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


